import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from 'react-auth-kit';
import { Save } from 'lucide-react';
import User from '../../../Models/User';
//import axios from 'axios';
import datas from "../../../Assets/data.json";
import UploadImage from '../../UploadImage';
import env from 'react-dotenv';
import { Crypter } from '../../../Functions/Security/Crypter';
import { FormSection, FormActions, useAlert, Spin, Input, Button } from '../../ui';


export interface ConfirmationDialogRawProps {
    classes: Record<'paper', string>;
    id: string;
    keepMounted: boolean;
    value: string;
    open: boolean;
    onClose: (value?: string) => void;
}

export interface Ticket {
    numeroFile: string,
    guichet: string,
    agence: String
}

const FormEntite = () => {

	// USER TOKEN
	const authHeader = useAuthHeader()
    // USER SESSION
    const auth = useAuthUser()
    const user: User = JSON.parse(JSON.stringify(auth() || {}))
    const alert = useAlert()

    const { register, handleSubmit, setValue, reset } = useForm()
    const [fichier, setFicher] = useState<File>()
    const [isOk, setIsOk] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    const [firstLetter, setfirstLetter] = useState('');
    const [firstLetters, setfirstLetters] = useState([])


    const onSubmit = async (data: any) => {
        data = {...data, CodeAbonne: user.CodeAbonne, CreatedBy: user.CodeU} 
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: env.API_BASE_URL + datas.API_LINKs.AddFiliales,
            headers: {
				'Authorization': authHeader(),
                'Content-Type': 'application/json'
            },
            data: Crypter.encrypt(JSON.stringify(data))
        };

        axios.request(config)
            .then((response) => {
                setLoading(false)
                const res = JSON.parse(Crypter.decrypt(response.data)).Value
                if (res.StatutCode == 200) {
                    //localStorage.setItem("loadQmGuichet", "1")
                    alert.success(res.Message)
                    reset()
                } else {
                    alert.warning(res.Message)
                }
            })
            .catch((error) => {
                setLoading(false)
                alert.error(error.message)
            })

    }


    return (
        <>
            <Spin spinning={loading}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormSection title="Identification" subtitle="Code et libellé de l'entité">
                        <Input
                            onKeyUp={() => setIsOk(false)}
                            {...register("CodeFiliale")}
                            required
                            type='text'
                            label={'Code Entité'}
                            placeholder={"Entrez le code de l'entité"} />
                        <Input
                            onKeyUp={() => setIsOk(false)}
                            {...register("Libelle")}
                            required
                            type='text'
                            label={'Libellé'}
                            placeholder={"Entrez le nom de l'entité"} />
                    </FormSection>

                    <FormSection title="Localisation & Contact" subtitle="Adresse, responsable et téléphone">
                        <Input
                            onKeyUp={() => setIsOk(false)}
                            {...register("Location")}
                            required
                            type='text'
                            label={'Localisation'}
                            placeholder={"Entrez la localisation de l'entité"} />
                        <Input
                            onKeyUp={() => setIsOk(false)}
                            {...register("HeadFiliale")}
                            required
                            type='text'
                            label={"Chef de l'entité"}
                            placeholder={"Chef de l'entitité"} />
                        <Input
                            onKeyUp={() => setIsOk(false)}
                            {...register("Phone")}
                            required
                            type='tel'
                            label={'Téléphone'}
                            placeholder={"Entrez le numéro de téléphone de l'entité"} />
                    </FormSection>

                    <FormActions>
                        <Button variant='secondary' type='submit' startIcon={<Save size={16} />}>Enregistrer</Button>
                    </FormActions>
                </form>
            </Spin>
        </>
    );
};

export default FormEntite;
